import React from "react";
import { useState, useEffect } from "react";
import { AiOutlineSearch } from "react-icons/ai";

import "./CountrySelector.css";
import MultiSelectedListItem from "./MultiSelectedListItem";

const CountrySelector = (props) => {
  const [filteredCountries, setFilteredCountries] = useState([]);
  const [searchText, setSearchText] = useState();

  // Effect that runs to filter the countries down to the available countries in the list
  // Runs every time the unique countries, the search text or the selected country changes
  useEffect(() => {
    let availableCountries = props.uniqueCountries.filter(
      (country) => !props.selectedCountries.includes(country)
    );
    let searchFilterCountries = availableCountries.filter((country) => {
      return (
        country
          .toLowerCase()
          .replace(/\u00fc/g, "u")
          .search(searchText) !== -1
      );
    });

    setFilteredCountries(searchFilterCountries);
  }, [props.uniqueCountries, props.selectedCountries, searchText]);

  const handleInputChange = (event) => {
    let value = event.target.value.toLowerCase().replace(/\u00fc/g, "u");
    setSearchText(value);
  };

  const handleAvailableClick = (event) => {
    props.setSelectedCountries([
      ...props.selectedCountries,
      event.target.innerText,
    ]);
  };

  const handleSelectedClick = (value) => {
    props.setSelectedCountries(
      props.selectedCountries.filter((country) => country !== value)
    );
  };

  const handleFocusClick = (value) => {
    props.setComparisonState("off");
    props.setSelectedCountry(value);
  };

  return (
    <div className="country-selector">
      <div className="country-selector__display--multi-selected">
        {props.selectedCountries.map((country) => {
          return (
            <MultiSelectedListItem
              key={country}
              value={country}
              onClick={(value) => {
                handleSelectedClick(value);
              }}
              onFocusClick={(value) => handleFocusClick(value)}
              focusAvailable={props.focusAvailable}
            />
          );
        })}
      </div>
      <div className="country-selector__search">
        <AiOutlineSearch
          className="AiOutlineSearch-symbol"
          color={"#212b57"}
          size={20}
        />
        <input
          className="country-selector__search-input"
          type="text"
          onChange={(event) => handleInputChange(event)}
          placeholder="Search states/provinces"
        ></input>
      </div>
      <div className="country-selector__display">
        <div className="country-selector__display--available">
          {filteredCountries.map((country) => {
            return (
              <div
                className="list-item"
                key={country}
                onClick={(event) => handleAvailableClick(event)}
              >
                {country}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default React.memo(CountrySelector);
